<template>
  <div id="footer">
    <!-- <router-link to="/Contact">
    IMEJ Tech.com
    </router-link> -->
    
    <a href="#/" class="logo-link">
      <img src="../assets/logo.svg" id="logo" alt="logo" />Get The Ball Rolling @ IMEJ Tech.com
    </a>
  </div>
</template>

<script>
export default {
  name: "Footer",
  components: {}
};
</script>

<style scoped>
#logo {
  height: 20px;
  padding-left: 0px;
}
#footer {
  background-color: #0d0004;
  background-image: url("https://www.transparenttextures.com/patterns/black-mamba.png");
  border-top: 5px solid #007bff;
  padding-left: 10px;
  padding-right: 10px;
  padding-bottom: 5px;
  color: white;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
</style>

